<!--首页模块二-->
<template>
  <div style="font-family: Alibaba">
    <!--成果案件标题-->
    <div class='title'>
      <div>
        <h1>
          <i class="el-icon-caret-right"></i>{{ cnNameTwo }}
        </h1>
        <p>{{ enNameTwo }}</p>
      </div>
    </div>
    <!--成果案件-->
    <el-row :gutter="20" class="box-width introduce">
      <el-col :lg="8" :md="12"  :sm="12" :xs="24" v-for="item in homeTwoVo.slice(0, 6)" :key="item.id" class="image-container">
        <a href="#" class='card_box' @click='handleProjectDetail(item.id)'>
          <el-card :body-style="{ padding: '0px' }" class="card_box" >
            <el-image
              alt="Image Description"
              v-if='item.fullPathUrl != null'
              :src='item.fullPathUrl'
              style="width: 100%"
              :fit="fit"></el-image>
            <div class="text">
              <h4 class="documenTitle">{{ item.title }}</h4>
            </div>
            <!--鼠标移入显示-->
            <div class="text-box">
              <div v-html="item.briefIntroduction" style="min-height: 174px">
              </div>
              <p style="text-align: center;bottom: 10px">点击查看详情</p>
            </div>
          </el-card>
        </a>
      </el-col>
      <a class="more" href="#" @click.prevent="navigateTo2">更多案例...</a>
    </el-row>
  </div>
</template>
<script>
import { findEnNameOne, findHomeTwo, findProjectOne } from '@/api/zh'

export default {
  created () {
  },
  data () {
    return {
      enNameTwo: '',
      cnNameTwo: '',
      homeTwoVo: [],
      fit: 'cover',
      url: require('@assets/images/index/chanping.png'),
      url1: require('@assets/images/index/chanping1.png'),
      url2: require('@assets/images/index/chanping2.png')
    }
  },
  mounted () {
    this.selectHTwo()
    this.selectProjectOne()
  },
  methods: {
    /** 查询英文名称 */
    selectEnName (cnEnNameId) {
      let that = this
      findEnNameOne(cnEnNameId).then(res => {
        let data = res.data
        that.enNameTwo = data.enName
        that.cnNameTwo = data.cnName
      })
    },
    async selectProjectOne () {
      let that = this
      await findProjectOne(0).then(res => {
        that.homeTwoVo = res.data
      })
    },
    async selectHTwo () {
      let that = this
      await findHomeTwo().then(res => {
        if (res.data.cnEnNameId !== null) {
          that.selectEnName(res.data.cnEnNameId)
        }
      })
    },
    handleTwoClick (item) {},
    /** 详情 */
    handleProjectDetail: function (id) {
      this.$router.push({
        path: '/caseDetails',
        query: {
          projectId: id
        }
      })
    },
    navigateTo2 () {
      const routeData = this.$router.resolve({
        path: 'project-zh',
        query: { tabId: '1869707497638625282' }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>
<style scoped>
.more{
  float: right;
  margin-right: 12px;
  color: #606266;
}
.more:hover{
  color: #2eabff;
}
</style>
